export default __webpack_public_path__ + "static/media/kitchen3-afterI-1920w.2d9486e5.png";